module.exports = __webpack_public_path__ + "img/landscape-green.ffbceff7.svg";